import React, {useState, useEffect} from "react";
// import Paypal from "./Assets/PaypalMethod.png";
import Paypal from "./Assets/paypalPaymentimg.png";
import CreditCard from "./Assets/CreditCardMethod.svg"
import GooglePay from "./Assets/GooglePayMethod.png"
import ApplePay from "./Assets/ApplePayMethod.png"
import BankTransfer from "./Assets/BankTransferMethod.svg"
import { useDispatch, useSelector } from "react-redux";
import { UpdateUserPaymentMethod } from "../../../Actions/StudentA";
import SettingsPopup from "../Popups/Popups";
import ReuseablePopup from "../../../Components/ReuseablePopups/ReuseablePopup";
import { validateEmail, validateCardNumber, validateExpiryDate, validateSecurityCode, validateZipCode } from "../../../Components/ReuseableFunctions/ValidationFunctions"
import errorMessageImage from "./Assets/errorMessage.png";

const PaymentMethod= ({setActiveTab, UserId}) => {
    const Dispatch = useDispatch();
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [paymentData, setPaymentData] = useState({
        paypal: { email: "", password: "" },
        "creditCard": {
        nameOnCard: "",
        cardNumber: "",
        expiryDate: "",
        securityCode: "",
        zipCode: "",
        // Brand:""
        },
        googlepay: { email: "", password: "" },
        applepay: { email: "", password: "" },
        "BankAccount": {
        bankName: "",
        accountHolderName: "",
        bankCode: "",
        branchCode: "",
        accountNumber: "",
        },
    });
    const [formErrors, setFormErrors] = useState({});
    const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
    const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");


    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const handlePaymentMethodChange = (e) => {
        setSelectedPaymentMethod(e.target.value);
    };

    const handleInputChange = (method, field, value) => {
        setPaymentData((prevState) => ({
          ...prevState,
          [method]: {
            ...prevState[method],
            [field]: value,
          },
        }));

        // Validate email format if the field is "email"
        if (field === "email") {
            if (value.trim() === "") {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                email: "Email is required",
            }));
            } else if (!validateEmail(value)) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                email: "Invalid email format",
            }));
            } else {
            // Clear email error if valid
            setFormErrors((prevErrors) => {
                const { email, ...rest } = prevErrors;
                return rest;
            });
            }
        }

      };
    
      const handleSubmit = async () => {
        // Step 1: Check if a payment method is selected
        if (!selectedPaymentMethod) {
            setFormErrors({ general: "Please select a payment method" });
            return;
        }

        const selectedData = paymentData[selectedPaymentMethod];
        const errors = {};

        Object.entries(selectedData).forEach(([key, value]) => {
            if (!value.trim()) {
            const formattedKey = key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase());
            errors[key] = `${formattedKey} is required`;
            }
        });

        // Extra email format validation
        if ("email" in selectedData && selectedData.email.trim()) {
            if (!validateEmail(selectedData.email)) {
            errors.email = "Invalid email format";
            }
        }

        if (selectedPaymentMethod === "creditCard") {
            const { nameOnCard, cardNumber, expiryDate, securityCode, zipCode } = selectedData;
          
            if (!validateCardNumber(cardNumber)) {
              errors.cardNumber = "Invalid card number (must be 16 digits)";
            }
            if (!validateExpiryDate(expiryDate)) {
              errors.expiryDate = "Invalid expiry date (use MM/YY)";
            }
            if (!validateSecurityCode(securityCode)) {
              errors.securityCode = "Invalid security code (3-4 digits)";
            }
            if (!validateZipCode(zipCode)) {
              errors.zipCode = "Invalid ZIP/Postal Code";
            }
          }

        if (selectedPaymentMethod === "BankAccount") {
        const {
            bankName,
            accountHolderName,
            bankCode,
            branchCode,
            accountNumber,
        } = selectedData;
        
        if (!bankName.trim()) {
            errors.bankName = "Bank name is required";
        }
        if (!accountHolderName.trim()) {
            errors.accountHolderName = "Account holder name is required";
        }
        if (!bankCode.trim() || !/^\d{3,10}$/.test(bankCode)) {
            errors.bankCode = "Invalid bank code (3-10 digits)";
        }
        if (!branchCode.trim() || !/^\d{3,10}$/.test(branchCode)) {
            errors.branchCode = "Invalid branch code (3-10 digits)";
        }
        if (!accountNumber.trim() || !/^\d{6,20}$/.test(accountNumber)) {
            errors.accountNumber = "Invalid account number (6-20 digits)";
        }
        } 

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
          

        setFormErrors({}); // Clear errors if all fields are valid
  
        const dataToSend = {
          method: selectedPaymentMethod,
          details: paymentData[selectedPaymentMethod],
        };
    
        console.log("dataToSend at the backend is:",dataToSend)

        // Dispatch(UpdateUserPaymentMethod(dataToSend, UserId,
        //     () => {
        //         setPaymentData((prevData) => ({
        //             ...prevData,
        //             [selectedPaymentMethod]: Object.fromEntries(
        //             Object.keys(prevData[selectedPaymentMethod]).map((key) => [key, ""])
        //             ),
        //         }));
            
        //         setSelectedPaymentMethod(null); // Optional: reset selection
        //         setShowPopup(true); // Show popup on successful update
        //     },
        //     (errorMessage) => {
        //         setErrorMessageText(errorMessage)
        //         setIsUpdationFailedPopup(true)
        //     }
        // ));

        Dispatch(UpdateUserPaymentMethod(
            dataToSend,
            UserId,
            () => {
                // Success callback
                setPaymentData((prevData) => ({
                    ...prevData,
                    [selectedPaymentMethod]: Object.fromEntries(
                        Object.keys(prevData[selectedPaymentMethod]).map((key) => [key, ""])
                    ),
                }));
                setSelectedPaymentMethod(null);
                setShowPopup(true);
            },
            (errorMessage) => {
                // Failure callback
                setErrorMessageText(errorMessage);
                setIsUpdationFailedPopup(true);
            }
        ));
        

        // Dispatch(UpdateUserPaymentMethod(dataToSend,UserId))
        // Dispatch(UpdateUserPaymentMethod(dataToSend,UserId))
        //   .then(() => {
        //      // Reset only the used payment method fields
        //     setPaymentData((prevData) => ({
        //         ...prevData,
        //         [selectedPaymentMethod]: Object.fromEntries(
        //         Object.keys(prevData[selectedPaymentMethod]).map((key) => [key, ""])
        //         ),
        //     }));
        
        //     setSelectedPaymentMethod(null); // Optional: reset selection
        //     setShowPopup(true); // Show popup on successful update
        //   })
        //   .catch((error) => {
        //     console.error("Error updating settings:", error);
        //     // Handle error if needed
        //   });
        // try {
        //   const response = await fetch("/api/save-payment", {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(dataToSend),
        //   });
    
        //   if (response.ok) {
        //     alert("Payment method saved successfully!");
        //   } else {
        //     alert("Failed to save payment method.");
        //   }
        // } catch (error) {
        //   console.error("Error saving payment method:", error);
        // }
      };

    return (
        <div className="w-full flex flex-col justify-center items-center gap-[10px]" >
            <div className="w-[85%] flex flex-start">
                <p className="hidden lg:block text-[#404040] text-[20px] font-bold">Add Payment Mehod</p>
            </div>
            <div className=" w-[100%] lg:w-[85%] flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[15px]">
                <p className="lg:hidden mb-[10px] text-[#404040] text-[20px] font-bold">Add Payment Mehod</p>
                <p className="text-[#000000] text-[18px] font-bold">Payment Method</p>
                <div className="mt-[10px] flex flex-col gap-[10px]">
                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="paypal"
                                    name="paymentMethod"
                                    value="paypal"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="paypal" className="text-[18px] text-[#707070]">
                                    PayPal
                                </label>
                            </div>
                            <div>
                                <img src={Paypal} alt="Paypal" className="h-[30px] w-[100px] object-contain" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "paypal" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                {formErrors.email && <h4 className="font-normal text-[red]">{formErrors.email}</h4>}

                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={paymentData.paypal.email}
                                    onChange={(e) =>
                                        handleInputChange("paypal", "email", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                {formErrors.password && <h4 className="font-normal text-[red]">{formErrors.password}</h4>}

                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={paymentData.paypal.password}
                                    onChange={(e) =>
                                        handleInputChange("paypal", "password", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="creditCard"
                                    name="paymentMethod"
                                    value="creditCard"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Credit Card" className="text-[18px] text-[#707070]">
                                Credit Card
                                </label>
                            </div>
                            <div>
                                <img src={CreditCard} alt="CreditCard" />
                            </div>
                        </div>

                        {selectedPaymentMethod === "creditCard" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                {formErrors.nameOnCard && <h4 className="font-normal text-[red]">{formErrors.nameOnCard}</h4>}
               
                                <input
                                    type="text"
                                    placeholder="Name on Card"
                                    value={paymentData.creditCard.nameOnCard}
                                    onChange={(e) =>
                                        handleInputChange("creditCard", "nameOnCard", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <div className="flex justify-between">
                                    <div className="w-full flex flex-col">
                                        {formErrors.cardNumber && <h4 className="font-normal text-[red]">{formErrors.cardNumber}</h4>}
                                        <input
                                            type="text"
                                            placeholder="Card Number"
                                            value={paymentData.creditCard.cardNumber}
                                            onChange={(e) =>
                                                handleInputChange("creditCard", "cardNumber", e.target.value)
                                            }
                                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                    {/* <div className="w-[49%] flex flex-col">
                                        {formErrors.Brand && <h4 className="font-normal text-[red]">{formErrors.Brand}</h4>}
                                        <input
                                            type="text"
                                            placeholder="Card Brand"
                                            value={paymentData.creditCard.Brand}
                                            onChange={(e) =>
                                                handleInputChange("creditCard", "Brand", e.target.value)
                                            }
                                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div> */}
                                </div>
                                <div className="flex justify-between">
                                    <div className="w-[49%] flex flex-col">
                                        {formErrors.expiryDate && <h4 className="font-normal text-[red]">{formErrors.expiryDate}</h4>}
                                        <input
                                            type="text"
                                            placeholder="Expiry date (MM/YY)"
                                            value={paymentData.creditCard.expiryDate}
                                            onChange={(e) =>
                                                handleInputChange("creditCard", "expiryDate", e.target.value)
                                            }
                                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                    <div className="w-[49%] flex flex-col">
                                        {formErrors.securityCode && <h4 className="font-normal text-[red]">{formErrors.securityCode}</h4>}
                                        <input
                                            type="text"
                                            placeholder="Security Code"
                                            value={paymentData.creditCard.securityCode}
                                            onChange={(e) =>
                                                handleInputChange("creditCard", "securityCode", e.target.value)
                                            }
                                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                </div>
                                {formErrors.zipCode && <h4 className="font-normal text-[red]">{formErrors.zipCode}</h4>}
                                <input
                                    type="text"
                                    placeholder="Zip/Postal Code"
                                    value={paymentData.creditCard.zipCode}
                                    onChange={(e) =>
                                        handleInputChange("creditCard", "zipCode", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="googlepay"
                                    name="paymentMethod"
                                    value="googlepay"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Google Pay" className="text-[18px] text-[#707070]">
                                    Google Pay
                                </label>
                            </div>
                            <div>
                                <img src={GooglePay} alt="GooglePay" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "googlepay" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                {formErrors.email && <h4 className="font-normal text-[red]">{formErrors.email}</h4>}

                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={paymentData.googlepay.email}
                                    onChange={(e) =>
                                        handleInputChange("googlepay", "email", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                {formErrors.password && <h4 className="font-normal text-[red]">{formErrors.password}</h4>}

                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={paymentData.googlepay.password}
                                    onChange={(e) =>
                                        handleInputChange("googlepay", "password", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="applepay"
                                    name="paymentMethod"
                                    value="applepay"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Apple Pay" className="text-[18px] text-[#707070]">
                                    Apple Pay
                                </label>
                            </div>
                            <div>
                                <img src={ApplePay} alt="ApplePay" className="h-[30px] w-[50px]" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "applepay" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                {formErrors.email && <h4 className="font-normal text-[red]">{formErrors.email}</h4>}
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={paymentData.applepay.email}
                                    onChange={(e) =>
                                        handleInputChange("applepay", "email", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                {formErrors.password && <h4 className="font-normal text-[red]">{formErrors.password}</h4>}
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={paymentData.applepay.password}
                                    onChange={(e) =>
                                        handleInputChange("applepay", "password", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>

                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="BankAccount"
                                    name="paymentMethod"
                                    value="BankAccount"
                                    onChange={handlePaymentMethodChange}
                                    className="mr-2"
                                />
                                <label htmlFor="Bank Account" className="text-[18px] text-[#707070]">
                                    Bank Account
                                </label>
                            </div>
                            <div>
                                <img src={BankTransfer} alt="BankTransfer" className="h-[30px]" />
                            </div>
                        </div>
                        {selectedPaymentMethod === "BankAccount" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                {formErrors.bankName && <h4 className="font-normal text-[red]">{formErrors.bankName}</h4>}

                                <input
                                    type="text"
                                    placeholder="Bank Name"
                                    value={paymentData.BankAccount.bankName}
                                    onChange={(e) =>
                                        handleInputChange("BankAccount", "bankName", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                {formErrors.accountHolderName && <h4 className="font-normal text-[red]">{formErrors.accountHolderName}</h4>}

                                <input
                                    type="text"
                                    placeholder="Account Holder's Name"
                                    value={paymentData.BankAccount.accountHolderName}
                                    onChange={(e) =>
                                        handleInputChange("BankAccount", "accountHolderName", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                                <div className="flex justify-between">
                                    <div className="w-[49%] flex flex-col">
                                        {formErrors.bankCode && <h4 className="font-normal text-[red]">{formErrors.bankCode}</h4>}
                                        <input
                                            type="text"
                                            placeholder="Bank/Institute Code"
                                            value={paymentData.BankAccount.bankCode}
                                            onChange={(e) =>
                                                handleInputChange("BankAccount", "bankCode", e.target.value)
                                            }
                                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                    <div className="w-[49%] flex flex-col">
                                        {formErrors.branchCode && <h4 className="font-normal text-[red]">{formErrors.branchCode}</h4>}
                                        <input
                                            type="text"
                                            placeholder="Branch/Transition Code"
                                            value={paymentData.BankAccount.branchCode}
                                            onChange={(e) =>
                                                handleInputChange("BankAccount", "branchCode", e.target.value)
                                            }
                                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                </div>
                                {formErrors.accountNumber && <h4 className="font-normal text-[red]">{formErrors.accountNumber}</h4>}
                                <input
                                    type="text"
                                    placeholder="Account Number"
                                    value={paymentData.BankAccount.accountNumber}
                                    onChange={(e) =>
                                        handleInputChange("BankAccount", "accountNumber", e.target.value)
                                    }
                                    className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {formErrors.general && (
                <h4 className="font-normal text-[red]">{formErrors.general}</h4>
            )}

            <div className="w-[100%] lg:w-[85%] flex justify-end gap-[20px] mt-[15px]">
                 <button
                    className="w-[150px] lg:w-[200px] h-[40px] rounded-[8px] bg-[#FFFFFF] text-[#A1A3EF] text-[18px]"
                    style={{border:"2px solid #A1A3EF"}}
                    onClick={() => setActiveTab("Subscriptions")}
                >
                    Back
                </button> 
                <button
                    className="w-[300px] lg:w-[250px] h-[40px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[18px]"
                    onClick={handleSubmit}
                >
                    Add Payment Method
                </button>
            </div>

            {/* {showPopup && (
                <SettingsPopup
                    setShowPopup={setShowPopup}
                    text="Your changes have been saved successfully!"
                />
            )} */}

            {showPopup && (
                <ReuseablePopup
                setShowPopup={setShowPopup}
                heading="Congratulations"
                text="Payment Method Saved Successfully"
                btnText="Done"
                onClick={() => setShowPopup(false)} // <-- Add this line
                imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
                />
            )}

            {isUpdationFailedPopup && (
                <ReuseablePopup
                setShowPopup={setIsUpdationFailedPopup}
                heading="Oops!"
                text={errorMessageText}
                btnText="Back"
                onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
                imageSrc={errorMessageImage} // ✅ Dynamic image source
                />
            )}
        </div>
    );
};

export default PaymentMethod;
